import { InvoiceStateContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import { useContext } from "react";

const useInvoice = (options?: Toolkit.GoogleAnalytics.Options) => {
    const invoiceContext = useContext(InvoiceStateContext).value;

    return options?.invoice || invoiceContext;
};

export default useInvoice;
